module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"alibabaCloudAccountsTable.accessKeyId":"Access Key Id","alibabaCloudAccountsTable.regionCode":"Region Code","alibabaCloudAccountsTable.expiry":"Expiry","alibabaCloudAccountsTable.noData":"No alibaba cloud connections configured.","alibabaCloudAccountsTable.disconnectedUsageConnection":"Please update your usage connection with valid credentials"}}')
  delete Component.options._Ctor
}
